import { IIcon } from "components/icons/icons.types";
import React from "react";

const PartyPopperIcon: React.FC<IIcon> = ({ width = 21, height = 22 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 21 22">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11.74.5h.02a.99.99 0 01.99.99v3.02a.99.99 0 01-.99.99h-.02a.99.99 0 01-.99-.99V1.49a.99.99 0 01.99-.99zM8.41 5.783l7.777 7.779a1.2 1.2 0 01.015 1.781l-.92.92a.5.5 0 01-.707 0l-8.839-8.84a.5.5 0 010-.706l.92-.92a1.2 1.2 0 011.697 0l.056-.014zM5.52 9.5l6.93 7a.5.5 0 01-.17.83L1.45 21.42a1 1 0 01-1.27-1.33L4.71 9.67a.5.5 0 01.81-.17zM16 9.86a1 1 0 011-1h3a1 1 0 110 2h-3a1 1 0 01-1-1zm-2.06-3.295a1 1 0 00.29.705 1 1 0 001.41-.01L19 3.9a1 1 0 000-1.4 1 1 0 00-1.41 0l-3.36 3.36a1 1 0 00-.29.705z"
      clipRule="evenodd"></path>
  </svg>
);

export { PartyPopperIcon };
